<template>
  <div class="tailsection_11 flex-col">
    <div id="map_container_box" style="width: 1000px;height: 300px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      CityInfo: {
        longitude: 139.791316,
        latitude: 35.694105
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this.initBaiduMap();
    });
  },
  methods: {
    initBaiduMap() {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://api.map.baidu.com/api?v=2.0&type=webgl&ak=HK8REl8sz56CFUZEXyX2FW9KWHkJFHes&callback=createMap";
      document.head.appendChild(script);
      window.createMap = () => {
        //创建Map实例
        var map = new BMapGL.Map("map_container_box"); // 创建Map实例
        map.centerAndZoom(
          new BMapGL.Point(this.CityInfo.longitude, this.CityInfo.latitude),
          15
        ); // 创建点坐标,初始化地图,设置中心点坐标和地图级别
        map.addControl(new BMapGL.MapTypeControl()); //添加地图类型控件
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
        map.enableInertialDragging(); //两秒后开启惯性拖拽
      };
    }
  }
};
</script>
<style scoped>
.article {
  display: flex;
  justify-content: center;
}

.link {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/demo111111.vue